import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useMoodsContext } from "store/contexts/moodsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import { useExpressionsContext } from "store/contexts/expressionsContext";
import classNames from "classnames";

var styles = {
  emoji: {
    width: "23px",
    height: "23px",
  },
  selectedEmoji: {
    width: "100%",
    height: "100%",
  },
  everyEmoji: {
    paddingTop: "8px",
    paddingBottom: "8px",
    borderLeft: "1px solid aliceblue",
    borderRight: "1px solid aliceblue",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  emojiList: {
    display: "flex",
    listStyle: "none",
  },
  boxShadow: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    background: "white",
  },
  moodName: {
    color: "#575f6b",
    fontSize: "10px",
    width: "max-content"
  }
};

function CommentReaction({ listTask, expression }) {
  const classes = styles;
  const [showMoods, setShowMoods] = useState(null);
  const { buzzes } = useMoodsContext();
  const { updateExpression } = useExpressionsContext();

  const showMoodsPooper = (event) => {
    setShowMoods(event.currentTarget);
  };

  const hideMoodsPooper = () => {
      setShowMoods(null);
  };

  const clearExpressionReaction = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    const expressionCopy = { ...expression };

    setShowMoods(null);
    if (expression.buzz_type_id) {
      expressionCopy.buzzes_count -= 1;
    }

    expressionCopy.buzz_type_id = null;

    TeamService.clearTaskCommentReaction(
      listTask.post.team_id,
      listTask.id,
      expressionCopy.id
    );
    updateExpression(expressionCopy);
  };

  const updateReaction = (newReactionId, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    if (newReactionId === expression?.buzz_type_id) {
      clearExpressionReaction(event);
      return;
    }

    setShowMoods(null);
    const expressionCopy = { ...expression };

    if (!expression.buzz_type_id) {
      expressionCopy.buzzes_count += 1;
    }

    expressionCopy.buzz_type_id = newReactionId;
    expressionCopy.reactions = null;

    TeamService.reactToTaskComment(
      listTask.post.team_id,
      listTask.id,
      expressionCopy.id,
      newReactionId
    );
    updateExpression(expressionCopy);
  };

  let selectedMood = buzzes?.find((buzzes) => {
    return buzzes?.id === expression?.buzz_type_id;
  });

  selectedMood = selectedMood ? (
    <img
      className="mwh-16"
      style={classes.selectedEmoji}
      src={selectedMood.media}
      alt={selectedMood.name}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSmile}
      style={classes.selectedEmoji}
      className="mwh-16"
    />
  );

  return (
    <div
      style={classes.relative}
      onMouseEnter={showMoodsPooper}
      onClick={showMoodsPooper}
      onMouseLeave={hideMoodsPooper}
      className="p-like-btn"
    >
      {expression?.buzz_type_id && selectedMood}
      {!expression?.buzz_type_id && (
        <FontAwesomeIcon
          className="mwh-16"
          style={classes.selectedEmoji}
          icon={faSmile}
        />
      )}
      <CSSTransition
        in={Boolean(showMoods)}
        timeout={300}
        unmountOnExit
        classNames="reaction-element"
      >
        <ClickAwayListener onClickAway={hideMoodsPooper}>
          <div style={classes.boxShadow} className="postMoods commentMoods">
            <ul style={classes.emojiList}>
              {buzzes?.map((mood) => (
                <li
                  className={classNames({
                    "emoji-mood": true,
                    "selected_emoji_mood": expression.buzz_type_id === mood.id ? true : false,
                  })}
                  onClick={(e) => updateReaction(mood.id, e)}
                  key={mood.name}
                  style={classes.everyEmoji}
                >
                  <img
                    src={mood.media}
                    alt={mood.name}
                    key={mood.id}
                    style={classes.emoji}
                  />
                    <span style={classes.moodName}>{mood.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
}

export default CommentReaction;
